import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'lib-not-supported-screen',
  imports: [TranslocoPipe],
  templateUrl: './not-supported-screen.component.html',
  styleUrl: './not-supported-screen.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class NotSupportedScreenComponent {}
